<template>
    <div :id="'sector_'+record.sector" class="clearfix rightLine  " :style="'display:'+graduallyView+';'">
        <div class="topMargin"></div>
        <div v-if="record.line1.trim().length>0" class="bold clearfix text-left">{{$t(record.line1)}}</div>
        <div v-if="record.line2.trim().length>0" class="clearfix text-left">{{$t(record.line2)}}</div>
        <div v-if="record.line3.trim().length>0" class="clearfix text-left">{{$t(record.line3)}}</div>
        <div v-if="record.line4.trim().length>0" class="clearfix text-left">{{$t(record.line4)}}</div>
        <div v-if="record.line5.trim().length>0" class="clearfix text-left">{{$t(record.line5)}}</div>
    </div>  
</template>

<script>
    export default {
        props: {
            record: {
                type: Object,
            },
            graduallyView: {
                type: String
            }
        },
    }
</script>

<style lang="scss" scoped>
    .topMargin {height:20px;}
</style>